import { render } from "./WalletCard.vue?vue&type=template&id=f4fda492"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/WalletCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4fda492"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4fda492', __exports__)) {
    api.reload('f4fda492', __exports__)
  }
  
  module.hot.accept("./WalletCard.vue?vue&type=template&id=f4fda492", () => {
    api.rerender('f4fda492', render)
  })

}


export default __exports__